import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import FocusGroupProvider from '@elliemae/ds-shared/FocusGroup/FocusGroupManager';

var pillGroupBlockName = 'pill-group';
var Container = aggregatedClasses('div')(pillGroupBlockName);

var PillGroup = function PillGroup(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      onFocusNextGroup = _ref.onFocusNextGroup,
      onFocusPreviousGroup = _ref.onFocusPreviousGroup,
      onFocusGroupSet = _ref.onFocusGroupSet,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(FocusGroupProvider, {
    keyBindings: {
      Tab: 'next'
    },
    onFocusGroupSet: onFocusGroupSet,
    onFocusNextGroup: onFocusNextGroup,
    onFocusPreviousGroup: onFocusPreviousGroup,
    orientation: "horizontal"
  }, /*#__PURE__*/React.createElement(Container, containerProps, children));
};

var props = {
  /** props injected to component wrapper */
  containerProps: PropTypes.object.description('props injected to component wrapper'),

  /** focus next group callback */
  onFocusNextGroup: PropTypes.func.description('focus next group callback'),

  /** focus prev group callback */
  onFocusPreviousGroup: PropTypes.func.description('focus prev group callback'),

  /** focus group set callback */
  onFocusGroupSet: PropTypes.func.description('focus group set callback'),

  /** pill components */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired.description('pill components')
};
PillGroup.propTypes = props;
var DSPillGroupWithSchema = describe(PillGroup);
DSPillGroupWithSchema.propTypes = props;

export { Container, DSPillGroupWithSchema, PillGroup };
//# sourceMappingURL=PillGroup.js.map
